const updateSvgProps = (svgStr, prop, newValue) => {
  let reg = `(${prop}=')([^']+)(')`;
  let regex1 = new RegExp(reg, 'g');
  return svgStr.replace(regex1, `$1${newValue}$3`);
};

export default updateSvgProps;
